module.exports = __webpack_public_path__ + "img/_dsc8130.4a24fe3a.jpg";